import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { NgChartsModule } from 'ng2-charts';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { NgxEditorModule } from 'ngx-editor';
import { provideNgxMask } from 'ngx-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';

//import { AgmCoreModule } from '@agm/core';
//import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from 'ngx-mat-datetime-picker';

//import { AgmCoreModule } from '@agm/core';
/*const AgmCoreModule = AgmCoreModule.forRoot({
    apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
})*/

@NgModule({
    imports: [
        NgxChartsModule,
        NgxDnDModule,
        NgChartsModule,
        FlexLayoutModule,
        FlexModule,
        NgxEditorModule,
        InfiniteScrollModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        //AgmCoreModule,
    ],
    exports: [
        NgxChartsModule,
        NgxDnDModule,
        NgChartsModule,
        FlexLayoutModule,
        FlexModule,
        NgxEditorModule,
        InfiniteScrollModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        //AgmCoreModule,

        // NgxMatDatetimePickerModule,
    //NgxMatTimepickerModule    

    //NgxMaskModule.forRoot(),
    ],
    providers:[provideNgxMask()]
})
export class ThirdSharedModule { }
